angular
  .module('app')
  .component('ngHeader', {
    templateUrl: 'app/components/bookingEngine/header/Header.html',
    controller: Header
  });

/** @ngInject */
function Header(ConfigHotel, ConfigBookingEngine, $state) {
  var $this = this;
  $this.ConfigHotel = ConfigHotel;
  $this.ConfigBookingEngine = ConfigBookingEngine;
  $this.$state = $state;
  $this.availableLanguages = ConfigBookingEngine.getAvailableLanguages();
  $this.isDiscountCodesEnabled = ConfigBookingEngine.isDiscountCodesEnabled();
  $this.siteTitle = ConfigHotel.getHotelName();
}

Header.prototype = {
  handleLanguageChange: function (langCode) {
    this.$state.go(this.$state.current, {
      language: langCode
    });
  },

  handleDiscountCodeSave: function (code) {
    this.$state.go(this.$state.current, {
      discountCode: code
    });
  }
};
